const BRAND = {
  name: "Mooving Grills Pizza",
  address: "Your Full Address Here",
  phone: "7669969989",
  gst: "xxxxxxxxxxxxxxx",
  logo: process.env.PUBLIC_URL + "/logo.png"
};

export default BRAND;